<template>
  <div class="col-12">
  <!-- Header Form -->
    <!-- <div class="d-flex justify-content-between" v-show="approval == true">
      <div>
        <h5 class="modal-title mb-2 mt-4 row mb-2">Detalhes da Proposta</h5>
        <h5 class="text-muted text-uppercase row h5 mb-4">Informações sobre proposta aberta para aprovação</h5>
      </div>
      <base-button
        @click="disableData = false"
        size="sm"
        outline
        type="purple"
        class="mt-4"
        style="max-height: 40px;"
        v-if="disableData == true"
        :disabled="notEdit"
      >
        <i class="fa fa-pencil-alt mt-2"></i>
          Editar Proposta
      </base-button>
    </div> -->
    <div v-if="approval == false" class="d-flex justify-content-between">
      <div>
        <h5 class="modal-title row mb-2 mt-4" id="exampleModalLabel">{{ proposal.id ? 'Visualizar Proposta' : 'Nova Proposta' }}</h5>
        <h5 class="text-muted row text-uppercase h5 mb-4">Autor: {{ user.name }}</h5>
      </div>
      <base-button
        @click="edit"
        size="sm"
        outline
        type="purple"
        class="mt-4"
        style="max-height: 40px;"
        v-if="disableData == true"
      >
        <i class="fa fa-pencil-alt mt-2"></i>
          Editar Proposta
      </base-button>
    </div>
    <div class="row d-flex justify-content-between">
      <card class="col-2">
        <h5 class="text-muted text-uppercase h5">Cliente</h5>
        <h5 class="mb-2 mt-2 h4">{{ proposal.client ? proposal.client.name : 'Nome do Cliente' }}</h5>
      </card>
      <card class="col-2">
        <h5 class="text-muted text-uppercase h5">Número da proposta</h5>
        <h5 class="h4 mb-2 mt-2">{{ proposal.id }}</h5>
      </card>
      <card class="col-2">
        <h5 class="text-muted text-uppercase h5">Data de Validade</h5>
        <h5 class="h4 mb-2 mt-2">{{ proposal.validity_date | formatDate }}</h5>
      </card>
      <card class="col-2">
        <h5 class="text-muted text-uppercase h5">Status</h5>
        <h5 class="h4 mb-2 mt-2">{{ getColor(proposal.status).value }}</h5>
      </card>
      <card class="col-2">
        <h5 class="text-muted text-uppercase h5">Etapa</h5>
        <h5 class="h4 mb-2 mt-2">{{ proposal.stage }}</h5>
      </card>
    </div>

    <!-- Form Proposal -->
    <validation-observer ref="observer">
      <form role="form">
        <div class="row">
          <div class="col-6 form-group">
            <label class="form-control-label">Cliente</label><span class="text-red"> *</span>
            <ValidationProvider
              vid="client"
              name="client"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <multiselect
                  v-model="proposalData.client"
                  :options="dataClients"
                  label="razao_social"
                  track-by="value"
                  select-label=""
                  deselect-label=""
                  placeholder="Selecionar Cliente"
                  :disabled="disableData == true"
                  :selected-label="'Selecionado'"
                  @search-change="getCriClients"
                  @input="getCultureIds"
                >
                </multiselect>
              </base-input>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <label class="form-control-label">Data de Validade</label><span class="text-red"> *</span>
            <ValidationProvider
              vid="validity_date"
              name="validity_date"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <el-date-picker
                  v-model="proposalData.validity_date"
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                  style="min-height: 40px;"
                  :disabled="disableData"
                >
                </el-date-picker>
              </base-input>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <label class="form-control-label">Moeda</label><span class="text-red"> *</span>
            <ValidationProvider
              vid="proposalData.coin"
              name="coin"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <multiselect
                  v-model="proposalData.coin"
                  :options="coins"
                  label="name"
                  track-by="title"
                  select-label=""
                  deselect-label=""
                  :disabled="disableData"
                  placeholder="Selecionar Moeda"
                  :selected-label="'Selecionado'">
                </multiselect>
              </base-input>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <label class="form-control-label">Ano Safra</label><span class="text-red"> *</span>
            <ValidationProvider
              vid="proposalData"
              name="harvest"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <multiselect
                  v-model="proposalData.anosafra"
                  :options="anosafras"
                  label="descricao"
                  track-by="value"
                  select-label=""
                  deselect-label=""
                  :disabled="disableData"
                  placeholder="Selecionar Safra"
                  :selected-label="'Selecionado'">
                </multiselect>
              </base-input>
            </ValidationProvider>
          </div>
          
          <!-- Roles/Team proposalData -->
          <h5 class="modal-title col-12 mb-4 mt-4 card-header" id="exampleModalLabel">Equipe responsável</h5>
          <div class="col-12">
            <label class="col-12 row form-control-label">Cargos</label>
            <ValidationProvider
              vid="role"
              name="roles"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <multiselect
                  v-model="proposalData.roles"
                  :options="roles"
                  label="description"
                  :taggable="true"
                  :multiple="true"
                  :disabled="disableData"
                  placeholder="Selecionar um ou mais cargos para integrar a equipe"
                  :selected-label="'Selecionado'"
                  :allow-empty="true"
                  track-by="id"
                  @input="updateRoles"
                >
                </multiselect>
              </base-input>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group" v-for="role in proposalData.roles" :key="role.id">
            <label class="form-control-label">{{ role.description }}</label><span class="text-red"> *</span>
            <ValidationProvider
              vid="role"
              name="roles"
              rules="required"
              v-slot="{ errors }"
            >
              <base-input
                :required="true"
                :error="errors[0]"
              >
                <multiselect
                  v-model="role.user"
                  :options="users"
                  label="name"
                  track-by="value"
                  select-label=""
                  deselect-label=""
                  :disabled="disableData"
                  :placeholder="'Selecionar ' + role.description"
                  :selected-label="'Selecionado'"
                  @search-change="getUsers"
                  >
                </multiselect>
              </base-input>
            </ValidationProvider>
          </div>
          <!-- <div class="col-12">
            <base-checkbox type="purple" v-model="proposalData.send_email">
              Receber e-mails do processo
            </base-checkbox>
          </div> -->
          
          <!-- Cultures -->
          <h5 class="modal-title col-12 mb-4 mt-4 card-header">Solicitação de Culturas e Créditos</h5>
          <div
            v-for="(culture, index) in proposalData.culture_attributes"
            :key="culture.id"
            class="col-12"
          >
            <div class="culture-form col-12 row" v-show="!culture._destroy">
              <div class="col-6 form-group">
                <label class="form-control-label">Cultura {{ index + 1 }}</label><span class="text-red"> *</span>
                <ValidationProvider
                  vid="culture"
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <base-input
                    :required="true"
                    :error="errors[0]"
                  >
                    <multiselect
                      v-model="culture.name"
                      :options="cultureIds"
                      label="culture_name"
                      select-label=""
                      deselect-label=""
                      :disabled="disableData"
                      track-by="id"
                      placeholder="Selecionar Cultura"
                      :selected-label="'Selecionado'">
                    </multiselect>
                  </base-input>
                </ValidationProvider>
              </div>
              <div class="col-5 form-group">
                <label class="form-control-label">Valor solicitado para a cultura {{ index + 1 }}</label><span class="text-red"> *</span>
                <ValidationProvider
                  vid="branch"
                  name="branch"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <base-input 
                    :required="true"
                    :error="errors[0]"
                    v-model="culture.solicited_value" 
                    mask="money"
                    :disabled="disableData"
                    placeholder="R$ 0"
                  ></base-input>
                </ValidationProvider>
              </div>
              <span 
                v-if="!index == 0 || disableData == true" 
                class="btn btn-sm btn-icon-only ml-4" 
                style="margin-top: 2.3rem;" 
                :disabled="disableData"
                @click="removeCulture(culture)"
              >
                <i class="fa fa-times text-red mt-2"></i>
              </span>
            </div>
          </div>
          <div class="p-2 flex-fill bd-highlight ml-2">
            <base-button
              outline
              type="purple"
              style="max-height: 3rem"
              @click="addCulture"
              :disabled="disableData"
            >
              <i class="fa fa-plus mt-2"></i>
              Adicionar cultura
            </base-button>
          </div>
        </div>
      </form>
    </validation-observer>

    <div v-show="approval == true">
      <h5 class="modal-title mb-2 mt-4 row mb-2">Análise</h5>
      <h5 class="text-muted text-uppercase row h5 mb-4">Análise sobre essa etapa da proposta</h5>
      <card class="row">
        <div class="row">
          <base-switch class="ml-3" v-model="approvedRadio"/>
          <span class="d-flex justify-content-center ml-4">Proposta aprovada</span>
        </div>
        <div class="row col-12 mt-4">
          <label class="form-control-label d-block mb-3">Justificativa</label>
          <textarea class="form-control" :value="justify" @input="upComment($event.target.value)" rows="3" placeholder="Justifique a decisão de aprovação ou reprovação da proposta."></textarea>
        </div>
      </card>
    </div>
    <div class="d-flex justify-content-end mb-4">
      <base-button type="secondary" @click="close" class="mr-2 col-2">Cancelar</base-button>
      <base-button :loading="loading" type="purple" v-if="!approval && !proposal.id" class="col-2" @click="save">Salvar</base-button>
      <base-button :loading="loading" type="purple" v-if="proposal.id && !approval" class="col-2" @click="update">Editar</base-button>
      <base-button :loading="loading" type="purple" v-if="approval" class="col-2" @click="updateApproval">Avaliar Etapa</base-button>
    </div>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import swal from 'sweetalert2';
import { DatePicker, Radio } from "element-ui";

// Validate library
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import BaseSwitch from '../../../components/BaseSwitch.vue';

extend("required", {
  ...required,
  message: "Este campo é obrigatório"
});

export default {
  name: 'proposal-form',
  components: { Multiselect, ValidationProvider, BaseSwitch, [DatePicker.name]: DatePicker, [Radio.name]: Radio,},
  props: {
    approval: {
      type: Boolean,
      default: false
    },
    authorized: {
      type: Boolean,
      default: false
    },
    justification: {
      type: String,
    },
    client: {
      type: Object
    },
    clients: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    proposal: {
      type: Object
    },
    notEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      anosafras: [],
      coins: [
        {
          id: 0,
          name: 'Real',
          title: 'real'
        },
        {
          id: 1,
          name: 'Dólar',
          title: 'dolar'
        }
      ],
      cultureIds: [],
      errors: [],
      roles: [],
      users: [],
      user: this.$currentUser(),
      loading: false,
      justify: ''
    }
  },
  mounted () {
    this.getAnosafras()
    this.getRoles()
    this.getUsers()
    this.approvedRadio =  this.authorized || false
    this.justify= this.justification
  },
  methods: {
    upComment(comment) {
      this.justify = comment
    },
    getCriClients (query) {
      var data = {
        per_page: 10,
        q: { name: query, status: true },
      }
      this.$http.secured
      .get("/api/v1/credit_analysis/get_clients", { params: data })
      .then((response) => {
        this.dataClients = response.data
       })
      .catch(error => console.log(error, "Something went wrong"))
    },
    addCulture() {
      this.proposalData.culture_attributes.push({ name: '', solicited_value: null})
      this.proposalData = Object.assign({}, this.proposalData, {
        culture_attributes: this.proposalData.culture_attributes
      })
    },
    clear() {
      this.proposalData = {
        culture_attributes: [
          {
            name: '',
            solicited_value: null
          }
        ]
      }
      this.disableData = false
    },
    close () {
      this.$emit('registerProposal', false)
      this.clear()
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ")
      const finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]
      return finalString
    },
    formatData () {
      const cultures = this.proposalData.culture_attributes.map(culture => { return {
        culture_code: culture.name ? culture.name.id : '',
        solicited_value: culture.solicited_value ? culture.solicited_value.toString().replace(/\D/g, '') : null,
        proposal_id: this.proposal.id,
        id: culture.id || null,
        _destroy: culture._destroy ? "1" : null
      }})

      const responsibles = this.proposalData.roles.map(role => { return {
        user_code: role.user.id, 
        role_id: role.id,
        proposal_id: this.proposalData.id,
        id: role.responsible_id || null
      }})
      
      const data = {
        id: this.proposalData.id || null,
        client_id: this.proposalData.client_id ? this.proposalData.client_id : this.proposal.client.id,
        validity_date: this.proposalData.validity_date,
        anosafra_code: this.proposalData.anosafra.id,
        author_id: this.user.id,
        coin: this.proposalData.coin.title,
        send_email: this.proposalData.send_email,
        status: 'analyse',
        responsible_proposals_attributes: responsibles,
        cultures_attributes: cultures,
      }

      return data
    },
    getColor (status) {
      if (status == 'disapproved') return {
        value: 'Reprovada'.toUpperCase()
      }
      else if (status == 'approved') return  {
        value: 'Aprovada'.toUpperCase()
      }
      else return {
        value: 'Em análise'.toUpperCase()
      } 
    },
    async getAnosafras () {
      const response = await this.$http.secured.get(`/api/v1/anosafras`)
      this.anosafras = response.data.anosafras
    },
    async getRoles () {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_roles")
      this.roles = response.data
    },
    getUsers(query) {
      const data = { per_page: 10, q: { name: query, status: true } }

      this.$http.secured.get("/api/v1/users", { params: data })
        .then((response) => ( this.users = response.data.users ))
        .catch(error => console.log(error, "Something went wrong"))
    },
    removeCulture(culture) {
      const result = swal.fire({
        title: `Excluir cultura ${ culture.name ? culture.name.culture_name : '' }?`,
        text: `Remover solicitação de crédito para a cultura ${ culture.name ? culture.name.culture_name : '' }`,
        showCancelButton: true,
        confirmButtonColor: '#F5365C',
        cancelButtonColor: '#8898aa',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Voltar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.proposalData.culture_attributes = this.proposalData.culture_attributes.filter(
            (c) => c != culture
          )
          if (culture.id != null) {
            this.proposalData.culture_attributes.push({  id: culture.id,  _destroy: "1", solicited_value: '', culture_code: culture.name})
          }
        }
      })
    },
    async save() {
      this.loading = true;
      this.$refs.observer.validate()
      if (!this.$refs.observer.validate()) return

      const data = this.formatData()
      const response = await this.$http.secured.post("/api/v1/credit_analysis/create_proposals", data)
      
      this.close()
      this.$emit('update-proposals', response.data)
      this.loading = false;
    },
    async update() {
      this.loading = true;
      this.$refs.observer.validate()
      if (!this.$refs.observer.validate()) return

      const data = this.formatData()
      const response = await this.$http.secured.put("/api/v1/credit_analysis/update_proposals", data)

      this.close()
      this.$emit('update-proposals', response.data)
      this.loading = false;
    },
    edit() {
      this.disableData = false;
      this.getCultureIds();
    },
    async updateApproval() {
      this.loading = true;
      const responsible = this.proposalData.roles.filter(responsible => responsible.user.id == this.user.id)[0]
      const analyse = {
        id: this.proposalData.proposal_analyses_attribute.id || null, 
        responsible_proposal_id: this.proposalData.proposal_analyses_attribute.responsible_proposal_id || responsible.responsible_id,
        proposal_id: this.proposalData.id,
        authorized: this.approvedRadio,
        justification: this.justify,
      }

      this.proposalData.proposal_analyses_attributes.push(analyse)

      const data = {
        id: this.proposalData.id,
        proposal_analyses_attributes: this.proposalData.proposal_analyses_attributes,
      }

      await this.$http.secured.put("/api/v1/credit_analysis/update_proposals", data)
      await this.$emit('on:changed')
      this.close()
      this.loading = false;
    },
    updateRoles() {
      this.proposalData = Object.assign({}, this.proposalData, {
        roles: this.proposalData.roles
      })
    },
    getCultureIds() {
      this.$http.secured
        .get("/api/v1/clients", { params: { code: this.proposalData.client.code } })
        .then((response) => (this.cultureIds = response.data.clients[0].culture_ids))
        .catch((error) => console.error(error, "Something went wrong"))
    },
  },
  computed: {
    dataClients: {
      get () {
        return this.clients || []
      },
      set (value) {
        this.clients = this.$emit('update:clients', value)
      }
    },
    approvedRadio: {
      get () {
        if (this.authorized) {
          return this.authorized || false
        }
      },
      set (authorized) {
        if (this.proposalData.proposal_analyses_attribute) {
          this.proposalData.proposal_analyses_attribute.authorized = authorized
        }
      }
    },
    proposalData: {
      get () {
        return this.proposal || {}
      },
      set (proposal) {
        this.$emit('update:proposal', proposal)
      }
    },
    disableData: {
      get () {
        return this.disabled || false
      },
      set (disabled) {
        this.$emit('update:disabled', disabled)
      }
    }
  }
}
</script>
